import React from 'react';
import { useAuth } from '../../Context/AuthContext';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import Navbar from '../../components/nav/NavBar';
import Footer from '../../components/footer/Footer';
import SideMenu from '../../components/ProfileSideMenu/SideMenu';
import Vector from '../../assets/images/Vector.svg';
import Profile_pic from '../../assets/images/profile_pic.svg';
import Pen from '../../assets/images/pen.svg';
import { Link } from 'react-router-dom';


export default function EditInfo() {
    const { uploadProfile, updateProfile, profile } = useAuth();

    const userData = JSON.parse(localStorage.getItem('userData'));
    const [image, setImage] = useState(userData.image_url)
    const form = useForm();
    const {
        register,
        handleSubmit,
    } = form;
    const addDefaultSrc = (ev) => {
        ev.target.src = Profile_pic;
    };
    const onImageChange = async (event) => {
        const file = event.target.files[0];

        if (file && event.target.files) {
            setImage(URL.createObjectURL(event.target.files[0]))
            const formData = new FormData();
            formData.append('file', file);
console.log("file"+formData.get('file'))

            try {
                await uploadProfile(formData);

            } catch (error) {
                console.error('Error uploading profile photo:', error);
            }
        }
    }


    const onSubmit = async (data) => {
        const { firstname, lastname } = data;
        console.log(firstname, lastname)
        await updateProfile(firstname, lastname);
        profile();

    }

    return (
        <>
            <Navbar />
            <div className='favourit-page-holder'>
                <div className='side-menu-component-holder'>
                    <SideMenu />
                </div>
                <div className='favourite-component-holder'>

                    <Link className='page-name-holder' to={'/profile-settings'}>
                        <img className='edit-icon left-arrow' src={Vector} alt='arrow-icon' />
                        <p className='edit-link'>Edit General Information</p>
                    </Link>
                    <div className='edit-info-holder'>
                        <div className='profile-pic-holder'>
                            <img className='profile-pic' onError={addDefaultSrc} src={image} alt='profile-pic' />
                        </div>
                        <div className='upload-image-holder'>
                            <label className='label-up-img' for="fileInput">
                                <img className='up-icon' src={Pen} alt="Upload Icon" />
                                Upload image
                            </label>
                            <input type="file" id='fileInput' onChange={onImageChange} className="filetype" />
                        </div>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div className='edit-info-input-holder'>
                                <div className='edit-name'>
                                    <label className='edit-label'>First Name</label>
                                    <input
                                        className='edit-input'
                                        type="text"
                                        placeholder={userData.firstName}
                                        {...register('firstname', {
                                            required: true,
                                            minLength: 3
                                        })}
                                    />

                                </div>
                                <div className='edit-name'>
                                    <label className='edit-label'>Last Name</label>
                                    <input
                                        className='edit-input'
                                        type="text"
                                        placeholder={userData.lastName}
                                        {...register('lastname', {
                                            required: true,
                                            minLength: 3
                                        })}
                                    />
                                </div>

                            </div>

                            <div className='save-btn-holder'>
                                <button className='save-button' type="submit">Save</button>
                            </div>

                        </form>

                    </div>


                </div>
            </div>
            <Footer />
        </>
    )
}
